<template>
  <div class="i-jca-hero">
    <div class="group-coaching">
      <img
        class="hero"
        :src="isSmOrLarger ? imageGroupCoaching : imageGroupCoachingMob"
      />
    </div>
    <div class="header">The JobTest Career Accelerator</div>
    <div class="sub">Focused, weekly sessions that turn exploration into action.</div>
    <div class="ctas">
      <iBaseButton
        v-bind="BUTTON_STYLE"
        @clicked="$emit('scroll-to-jca-intro')"
      />
      <iBaseButton
        v-bind="BUTTON_STYLE"
        text="Browse Past Sessions & Tools"
        @clicked="$emit('open-jca-resources')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { white } from "@/styles/colors"
import { breakpointSm } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

import iBaseButton from "@/components/base/BaseButton.vue"

// ASSETS
import imageGroupCoaching from "@/assets/heros/group-coaching.avif"
import imageGroupCoachingMob from "@/assets/heros/group-coaching-mob.avif"
import iconArrowRight from "@/assets/icons/icon-arrow-right-white.svg"

// EMITS
defineEmits(["scroll-to-jca-intro", "open-jca-resources"])

// COMPOSABLES
const isSmOrLarger = useIsScreenSize(breakpointSm)

// CONSTANTS
const BUTTON_STYLE = {
  size: "medium",
  fontWeight: "500",
  width: "fit-content",
  backgroundImage: "linear-gradient(to right, #9810FA, #155DFC)",
  borderRadius: "12px",
  textColor: white,
  text: "Learn More",
  iconUrl: iconArrowRight
}
</script>

<style scoped lang="scss">
.i-jca-hero {
  @include flex(column, center, stretch, $gap: 20px);

  width: 100%;
  height: 350px;
  color: $white;
  padding: 0 0 24px;

  @media screen and (min-width: $breakpoint-md) {
    height: 452px;
  }

  .group-coaching {
    position: absolute;
    width: 100vw;
    height: 374px;
    top: 96px;
    right: 0;
    z-index: -1;
    background-color: $black;

    @media screen and (min-width: $breakpoint-md) {
      height: 476px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      top: 128px;
    }

    /* stylelint-disable-next-line media-feature-range-notation */
    @media screen and (min-width: 1700px) {
      background-color: unset;
    }

    .hero {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: right top;

      /* stylelint-disable-next-line media-feature-range-notation */
      @media screen and (min-width: 1700px) {
        object-fit: contain;
        object-position: unset;
      }
    }
  }

  .header {
    @include display-md;

    font-weight: 700;
    max-width: 500px;

    @media screen and (min-width: $breakpoint-md) {
      @include display-lg;

      max-width: 600px;
    }
  }

  .sub {
    @include text-lg;

    max-width: 100%;

    @media screen and (min-width: $breakpoint-xs) {
      max-width: 75%;
    }

    @media screen and (min-width: $breakpoint-md) {
      @include text-xl;

      max-width: 550px;
    }
  }

  .ctas {
    @include flex(column, left, left, $gap: 16px);

    @media screen and (min-width: $breakpoint-md) {
      @include flex(row, left, left, $gap: 32px);
    }
  }
}
</style>
